export default __webpack_public_path__ + "static/shutdown-banner-web-f631cee38e2dfda7af6a16c6f3687bdb.png";